import axios from "axios";
import { getApiUrl } from "@/core/services/get-api-url";

import type {
  GetTodosParams,
  GetTodosResponse,
  CreateTodoParams,
  CreateTodoResponse,
} from "@/tasks/types";

const urlBase = getApiUrl("tasks");

const getTodos = async (
  params?: GetTodosParams,
  signal?: AbortSignal,
): Promise<GetTodosResponse> => {
  const { data } = await axios.get<GetTodosResponse>(`${urlBase}/todos`, {
    params,
    signal,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  if (params?.limit && data) {
    return data.slice(0, params.limit);
  }

  return data;
};

const createTodo = async (
  params: CreateTodoParams,
  signal?: AbortSignal,
): Promise<CreateTodoResponse> => {
  const { data } = await axios.post<CreateTodoResponse>(
    `${urlBase}/todos`,
    params,
    {
      signal,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    },
  );

  return data;
};

const updateTodo = async (
  id: number,
  params: Partial<CreateTodoParams>,
  signal?: AbortSignal,
): Promise<CreateTodoResponse> => {
  const { data } = await axios.put<CreateTodoResponse>(
    `${urlBase}/todos/${id}`,
    params,
    {
      signal,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    },
  );

  return data;
};

const deleteTodo = async (id: number, signal?: AbortSignal): Promise<void> => {
  await axios.delete(`${urlBase}/todos/${id}`, {
    signal,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export { getTodos, createTodo, updateTodo, deleteTodo };
